import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Spinner from "src/components/Spinner";
import { formatAmount, sanitizeNumericString } from "src/utils/formatters";

const LEADERBOARD_API_URL =
  "https://script.google.com/macros/s/AKfycbyzGNgj_i0SKSXPlEEErNTAgFOOLrX5D_DNOqSxiRxSwIzvmPHHkeTTdl_X4EjN1yI2EQ/exec";

const DEFAULT_LEADER_NAME = "";
const DEFAULT_LEADER_AMOUNT = "$0";

const formatLeaderboardAmount = (value) => {
  const cleaned = sanitizeNumericString(value);
  const formatted = formatAmount(cleaned, "en");
  return formatted || null;
};

const parseLeaderboardPayload = (data) => {
  let nextName = DEFAULT_LEADER_NAME;
  let nextAmount = DEFAULT_LEADER_AMOUNT;

  if (data && typeof data === "object" && !Array.isArray(data)) {
    if (data.name || data.name === 0) {
      nextName = String(data.name).trim() || DEFAULT_LEADER_NAME;
    }

    const parsedAmount = formatLeaderboardAmount(data.amount);
    if (parsedAmount) {
      nextAmount = parsedAmount;
    }
  } else if (typeof data === "string") {
    const parts = data.split(/[-:]/);
    if (parts.length >= 2) {
      const possibleName = parts[0].trim();
      const possibleAmount = formatLeaderboardAmount(parts.slice(1).join(" "));
      if (possibleName) {
        nextName = possibleName;
      }
      if (possibleAmount) {
        nextAmount = possibleAmount;
      }
    }
  }

  return { nextName, nextAmount };
};

const Cashnado2026TV = () => {
  const [leaderName, setLeaderName] = useState(DEFAULT_LEADER_NAME);
  const [leaderAmount, setLeaderAmount] = useState(DEFAULT_LEADER_AMOUNT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`${LEADERBOARD_API_URL}?t=${timestamp}`);
        const rawText = await response.text();

        let data;
        try {
          data = JSON.parse(rawText);
        } catch {
          data = rawText;
        }

        const { nextName, nextAmount } = parseLeaderboardPayload(data);

        setLeaderName(nextName);
        setLeaderAmount(nextAmount);
      } catch (error) {
        console.error("Error fetching Cashnado 2026 TV data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboardData();
    const interval = setInterval(fetchLeaderboardData, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TVContainer>
      <BackgroundVideo autoPlay muted loop playsInline>
        <source src="/videos/Cashnado-Game-finale_v2.mp4" type="video/mp4" />
      </BackgroundVideo>

      <ValuesStack>
        <NameOverlay>
          {loading ? <Spinner variant="dark" /> : <NameValue>{leaderName}</NameValue>}
        </NameOverlay>

        <AmountOverlay>
          {loading ? (
            <Spinner variant="dark" />
          ) : (
            <AmountValue>{leaderAmount}</AmountValue>
          )}
        </AmountOverlay>
      </ValuesStack>
    </TVContainer>
  );
};

const TVContainer = styled.div`
  width: 1120px;
  height: 756px;
  background-color: #000;
  color: white;
  overflow: hidden;
  position: relative;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

const ValuesStack = styled.div`
  position: absolute;
  left: 50%;
  bottom: 11.2%;
  transform: translateX(-50%);
  z-index: 3;
  width: 56%;
  max-width: 620px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 84px;
`;

const NameOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .spinner {
    position: relative;
    bottom: 85px;
  }
`;

const AmountOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .spinner {
    position: relative;
    bottom: 28px;
  }
`;

const NameValue = styled.div`
  font-size: 5rem;
  white-space: nowrap;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
  background: linear-gradient(180deg, #85091f 0%, #cd0000 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-text-stroke: 2px #ffffff;
  letter-spacing: -0.02em;
`;

const AmountValue = styled.div`
  font-size: 5rem;
  white-space: nowrap;
  font-weight: 900;
  line-height: 1;
  background: linear-gradient(180deg, #85091f 0%, #cd0000 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-text-stroke: 2px #ffffff;
  letter-spacing: -0.02em;
`;

export default Cashnado2026TV;
